import { load_one } from '../action-helpers.js'

export default {

    loadAllByProducts({ dispatch }, { products }) {
        const promises = products
            .map(product => product.type)
            .map(id => dispatch('loadOne', { id }))

        return Promise.all(promises)
    },

    loadOne: load_one('product-types/:id')

}
